/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddressCreatedRequest } from './address-created-request';
/**
 * 
 * @export
 * @interface ShipmentDetailsDto
 */
export interface ShipmentDetailsDto {
  _id?: string;
    /**
     * 
     * @type {AddressCreatedRequest}
     * @memberof ShipmentDetailsDto
     */
    addressFrom: AddressCreatedRequest;
    /**
     * 
     * @type {AddressCreatedRequest}
     * @memberof ShipmentDetailsDto
     */
    addressTo: AddressCreatedRequest;
    /**
     * 
     * @type {Date}
     * @memberof ShipmentDetailsDto
     */
    objectCreated: Date;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDetailsDto
     */
    objectId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDetailsDto
     */
    objectOwner: string;
    /**
     * 
     * @type {Date}
     * @memberof ShipmentDetailsDto
     */
    objectUpdated: Date;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDetailsDto
     */
    status: ShipmentDetailsDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentDetailsDto
     */
    test: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDetailsDto
     */
    metadata: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ShipmentDetailsDtoStatusEnum {
    ERROR = 'ERROR',
    QUEUED = 'QUEUED',
    SUCCESS = 'SUCCESS',
    WAITING = 'WAITING'
}

